

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
 Form, Grid, Input, Modal, Button,
} from 'framework-ui-components';

import {modificaSegnalibro} from "../../../apis/setteTrentaApi";

class ModaleStampa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            segnalibro: this.props.segnalibro,
        };
    }

    annulla =  () => {
        this.props.onClose && this.props.onClose();
    }

    modifica = () => {
        modificaSegnalibro(this.props.idDichiarazione,this.state.segnalibro).then(x => {
            this.annulla();
        })
    }

    render() {
        return (
            <Modal show onClose={this.annulla} className="printerDialog">
                <Modal.Header>Modifica segnalibro</Modal.Header>
                <Modal.Body>
                    <Form stato={this.state} onChange={(data) => this.setState(data)}>
                        <Grid fluid>
                            <Grid.Row className="mb-8">
                                <Grid.Col md="12">
                                    <Input name="segnalibro" title="Segnalibro" maxLength={50}/>
                                </Grid.Col>

                            </Grid.Row>
                        </Grid>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button flat onClick={this.annulla}>Annulla</Button>
                    <Button flat primary onClick={this.modifica}>Modifica</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

ModaleStampa.propTypes = {
    segnalibro: PropTypes.string,
    idDichiarazione: PropTypes.number,
};

export default ModaleStampa;
